export default {
  SET_LOCALE(state, locale) {
    state.locale = locale
  },
}
